import { Title } from '../typography/Heading';
import ButtonBase from '../button/ButtonBase';
import styles from './user-or-organization-box.module.less';
import Image from '../image/Image';

const UserOrOrganizationBox = ({ name, imgUrl, checked = false, className = '', onClick, showX }) => {
    return (
        <ButtonBase
            disabled={!onClick}
            className={`${className} ${checked ? styles.checkedContainer : styles.container}`}
            onClick={onClick}
        >
            <Image alt="" role="presentation" className={styles.image} src={imgUrl} />
            <Title tag={'div'} className={styles.name}>
                {name}
            </Title>
            {showX && <Image src="close.svg" alt="Lukk" className={styles.closeImage} />}
        </ButtonBase>
    );
};

export default UserOrOrganizationBox;
